export default __webpack_public_path__ + "static/media/oven.7fce38aa.svg";